import { useState } from 'react';

import { Grid } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DateRangePicker, MultiInputDateRangeField } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ptBR } from 'date-fns/locale';

import { CissTextField } from 'components/fields';
import { Filter } from 'components/filter';
import { FilterValuesProps } from 'hooks/useFilter';
import { GerarReembolsoStatusAutoComplete } from 'pages/financeiro/reembolso/gerar-reembolso/components';

export function ManutencaoReembolsoGridFilter() {


    const [filterStatus, setFilterStatus] = useState<FilterValuesProps>({
        property: 'idStatusApuracao',
        idProperty: 'idStatusApuracao',
        operator: 'eq',
        value: null,
    });

    const [filterCdApuracao, setFilterCdApuracao] = useState<FilterValuesProps>({
        property: 'cdApuracaoFormatado',
        operator: 'like',
        value: null,
    });

    const [filterDtGeracao, setFilterDtGeracao] = useState<FilterValuesProps>({
        property: 'dhInclusao',
        operator: 'bt',
        startDate: null,
        endDate: null,
    });

    return (
        <Filter
            preventQueryParamsEmptyStart
            filters={[
                { value: filterDtGeracao, setter: setFilterDtGeracao },
                { value: filterCdApuracao, setter: setFilterCdApuracao },
                { value: filterStatus, setter: setFilterStatus },
            ]}
        >
            <Grid sx={{ width: '100%' }} size={{ lg: 4 }}>
                <LocalizationProvider
                    adapterLocale={ptBR}
                    dateAdapter={AdapterDateFns}
                    localeText={{ start: 'Data de início da geração', end: 'Data de fim da geração' }}
                >
                    <DateRangePicker
                        value={[filterDtGeracao.startDate ?? null, filterDtGeracao.endDate ?? null]}
                        maxDate={new Date()}
                        onChange={([startDate, endDate]) =>
                            setFilterDtGeracao((oldState: FilterValuesProps) => ({ ...oldState, startDate, endDate }))
                        }
                        slots={{ field: MultiInputDateRangeField }}
                        slotProps={{
                            field: { dateSeparator: 'até' },
                            textField: { autoComplete: 'off', size: 'small' },
                        }}
                    />
                </LocalizationProvider>
            </Grid>
            <Grid size={{ lg: 4 }}>
                <CissTextField
                    size="small"
                    label="Código da apuração"
                    value={filterCdApuracao.value}
                    onChange={(e) => setFilterCdApuracao((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>
            <Grid size={{ lg: 4 }}>
                <GerarReembolsoStatusAutoComplete
                    value={filterStatus.value}
                    onChange={(e, value) => setFilterStatus((oldState: FilterValuesProps) => ({ ...oldState, value }))}
                    requestOptions={{
                        url: '/financeiro/statusapuracao',
                        sort: [{ property: 'idStatusApuracao', direction: 'ASC' }],
                        filter: [{ property: 'idStatusApuracao', operator: 'neq', value: 1 }],
                        nested: true,
                        limit: 50,
                    }}
                />
            </Grid>
        </Filter>
    );
}
